<template>
  <!--
   <div>
    <div v-if="isGranted([permissions.SYSTEM_ACCESS_CONTROL_VIEW, permissions.SYSTEM_ACCESS_CONTROL_VIEW_OWN], system)"
         class="card access_control"
         qid="access-control-section"
         id="update_access_control"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="access-control-table-title" v-if="!showOnTask">
                {{ $t('systems.access_control.title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_access_control')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_access_control')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_access_control')"
                      class="cursor-pointer"
                      @click="openHelpCenter(getGuide('update_access_control'))"
                >
                  <font-awesome-icon icon="info-circle"/>
                  {{ $t('system.help_center_label') }}
                </span>
              </span>
            </div>
            <div class="validation-info" qid="view-ac-validation" v-if="!showOnTask">
              <span v-if="validation && validation.validation === 1" qid="access-control-validation-approved">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
                {{ $t('system.approved') }}
              </span>
              <span v-if="validation && validation.validation === 0" qid="access-control-validation-rejected">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
                {{ $t('system.rejected') }}
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.by') }}
                <span v-if="validation.created_by" qid="view-ac-validation-by">
                  {{ validation.created_by.name }}
                </span>
              </span>
              <span v-if="validation" class="text-muted font-italic">
                {{ $t('system.on') }}
                <span v-if="validation.created_at" qid="view-ac-validation-date">
                  {{ validation.created_at | formatDate }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <ValidationForm
                :object="system"
                type="access_control"
                scope="validate_access_control"
                :checklist="validationOptions"
                :disabledItems="disabledValidationOptions"
                @validationModalClose="handleValidationModalClose"
                v-if="!showOnTask && isGranted([permissions.SYSTEM_ACCESS_CONTROL_VALIDATE, permissions.SYSTEM_ACCESS_CONTROL_VALIDATE_OWN], system)"
            ></ValidationForm>
            <span class="btn btn-success"
                  @click="showCreateACModal()"
                  qid="access-control-create-button"
                  v-if="isGranted([permissions.SYSTEM_ACCESS_CONTROL_CREATE, permissions.SYSTEM_ACCESS_CONTROL_CREATE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('systems.access_control.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('systems.access_control.table.name') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.access_control.table.provisioning') }}
              </th>
              <th scope="col" class="text-center">
                {{ $t('systems.access_control.table.re_certification') }}
              </th>
              <th scope="col">
                {{ $t('system.last_updated') }}
              </th>
              <th width="200"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="object in acTableItems">
              <td>
                <span v-if="object.access_control && object.access_control.name"
                      @click="openViewModal(object)"
                      qid="access-control-link"
                      class="btn btn-link btn-sm text-left cursor-pointer"
                >
                  {{ object.access_control.name }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.provisioning">
                  {{ $t('systems.access_control.' + $options.filters.slugify(object.provisioning)) }}
                </span>
              </td>
              <td class="text-center">
                <span v-if="object && object.re_certification">
                  {{ $t('systems.access_control.' + $options.filters.slugify(object.re_certification)) }}
                </span>
              </td>
              <td>
                <span>
                  <Avatar :object="object.updated_by" size="xs" class="mr-2" v-if="object.updated_by"></Avatar>
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td class="text-right">
                <span v-if="object.access_control && object.access_control.name"
                      @click="openViewModal(object)"
                      qid="access-control-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-edit"
                        qid="edit-ac-modal"
                        @click="showEditACModal(object)"
                        v-if="isGranted([permissions.SYSTEM_ACCESS_CONTROL_EDIT, permissions.SYSTEM_ACCESS_CONTROL_EDIT_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span class="btn btn-delete"
                        qid="delete-ac-modal"
                        @click="showACConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.SYSTEM_ACCESS_CONTROL_DELETE, permissions.SYSTEM_ACCESS_CONTROL_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!acLoading && !acTableItems.length" qid="no-results-row-ac" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div class="text-center mb-4" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="acValidationShow = !acValidationShow"
                qid="access-control-validation-expand"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!acValidationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="acValidationShow"/>
          </span>
        </div>
        <hr class="mb-0" v-show="acValidationShow && !showOnTask">
        <ValidationList
            :object="system"
            type="access_control"
            :reloadList="updateValidationList"
            @validationListUpdated="setValidation"
            v-show="acValidationShow && !showOnTask"
        ></ValidationList>
      </div>
    </div>


    <b-modal ref="delete-ac" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-ac-title">
          {{ $t('systems.access_control.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('systems.access_control.delete.description') }}
        <span v-if="itemToDelete.access_control">{{ itemToDelete.access_control.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('systems.access_control.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideACConfirmDeleteModal"
                  qid="delete-ac-cancel-button"
        >
          {{ $t('systems.access_control.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteAC(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-ac-submit-button"
                  v-if="isGranted([permissions.SYSTEM_ACCESS_CONTROL_DELETE, permissions.SYSTEM_ACCESS_CONTROL_DELETE_OWN], system) && (!getClient.parent || (getClient.parent && system.partition))"
        >
          {{ $t('systems.access_control.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <b-modal ref="add-access-control" hide-footer @hide="hideCreateACModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('systems.access_control.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="acFormSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('systems.access_control.create.ac_label') }}
            </label>
            <multiselect
                v-model="selectedAC"
                :options="acItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.access_control.create.ac_placeholder')"
                label="name"
                @search-change="debounceAccessControls"
                @select="resetFields"
                track-by="slug"
                qid="create-ac-form-ac"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.provisioning">
            <label qid="create-ac-provisioning-label">
              {{ $t('systems.access_control.create.provisioning_label') }}
            </label>
            <multiselect
                v-model="selectedP"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :options="provisioningOptions"
                label="name"
                :placeholder="$t('systems.access_control.create.provisioning_placeholder')"
                qid="create-ac-form-provisioning"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.re_certification">
            <label qid="create-ac-rc-label">
              {{ $t('systems.access_control.create.re_certification_label') }}
            </label>
            <multiselect
                v-model="selectedRC"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :options="reCertificationOptions"
                :placeholder="$t('systems.access_control.create.re_certification_placeholder')"
                qid="create-ac-form-rc"
                label="name"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.id">
            <label qid="create-ac-description-label">
              {{ $t('systems.access_control.create.description_label') }}
            </label>
            <b-form-textarea
              qid="ac-form-description"
              v-model="acForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.access_control.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateACModal"
                    qid="create-ac-cancel-button"
          >
            {{ $t('systems.access_control.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-ac-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.access_control.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <b-modal ref="edit-ac" hide-footer @hide="hideEditACModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('systems.access_control.edit.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formEditACSubmit" qid="edit-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-ac-label">
              {{ $t('systems.access_control.create.ac_label') }}
            </label>
            <br>
            <span v-if="selectedAC">
              {{selectedAC.name}}
            </span>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.provisioning">
            <label qid="create-ac-provisioning-label">
              {{ $t('systems.access_control.create.provisioning_label') }}
            </label>
            <multiselect
                v-model="selectedP"
                :options="provisioningOptions"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.access_control.create.provisioning_placeholder')"
                qid="create-ac-form-provisioning"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.re_certification">
            <label qid="create-ac-rc-label">
              {{ $t('systems.access_control.create.re_certification_label') }}
            </label>
            <multiselect
                v-model="selectedRC"
                :options="reCertificationOptions"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.access_control.create.re_certification_placeholder')"
                qid="create-ac-form-rc"
                label="name"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAC && selectedAC.id">
            <label qid="create-ac-description-label">
              {{ $t('systems.access_control.create.description_label') }}
            </label>
            <b-form-textarea
              qid="ac-form-description"
              v-model="acForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('systems.access_control.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditACModal"
                    qid="create-ac-cancel-button"
          >
            {{ $t('processes.legal_basis.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-ac-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('processes.legal_basis.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <AccessControlViewModal
        :object="selectedAC"
        v-if="selectedAC"
        :showModal="viewACModal"
        @closeViewModal="closeViewModal"
    ></AccessControlViewModal>

  </div>

  -->

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import AccessControlViewModal from '@/views/Systems/AccessControlViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';

  export default {
    name: 'AccessControlTable',
    data: function() {
      return {
        acForm: {
          name: '',
          provisioning: '',
          re_certification: '',
          description: ''
        },
        error: '',
        loadingItems: false,
        selectedAC: [],
        viewACModal: false,
        editACModal: false,
        selectedACSort: '',
        selectedACDirection: '',
        acValidationShow: false,
        acTableItems: [],
        acLoading: true,
        acItems: [],
        updateValidationList: false,
        itemToDelete: {},
        object: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        buttonDisabled: false,
        viewACModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      system: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      AccessControlViewModal,
      UpdateSingleTaskModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadAC();
      },
      system: function (value) {
        if (value && value.slug) {
          this.loadTasks('update_access_control');
          this.loadAccessControl();
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.system.id && this.$store.state.updatedObject.who_am_i == this.system.who_am_i) {
              this.system = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_access_control')
        }
      },
    },
    methods: {
      debounceAccessControls: _.debounce(function(query) {
        this.loadAC(query)
      }, 400),
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadAccessControl();
        this.loadTasks('update_access_control');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.system.who_am_i,
              model_id: this.system.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'System' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'System',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      openHelpCenter(object) {
        let topElement = document.getElementById("app");
        if (topElement.classList.contains("guide-collapsed")) {
          topElement.classList.toggle("guide-collapsed");
        }
        if (!topElement.classList.contains("activity-collapsed")) {
          topElement.classList.toggle("activity-collapsed");
        }

        this.$store.commit('storeHelpCenterState', true);
        this.$store.commit('storeActiveGuideScope', object);
      },
      resetFields() {
        this.selectedRC = null
        this.selectedP = null
      },
      setValidation(object) {
        this.validation = object
      },
      openEditACModal(object) {
        this.selectedAC = object
      },
      showCreateACModal() {
        this.$refs['add-access-control'].show()
      },
      hideCreateACModal() {
        this.error = ''
        this.selectedAC = []
        this.selectedRC = []
        this.selectedP = []
        this.acForm.description = ''
        this.loadContent()
        this.$refs['add-access-control'].hide()
      },
      showEditACModal(object) {
        let self = this;
        this.selectedAC = object.access_control

        this.selectedP = []
        if (object.provisioning) {
          _.find(this.provisioningOptions, function(item) {
            if (item.value == object.provisioning) {
              self.selectedP = item;
            }
          });
        }

        this.selectedRC = []
        if (object.re_certification) {
          _.find(this.reCertificationOptions, function(item) {
            if (item.value == object.re_certification) {
              self.selectedRC = item;
            }
          });
        }

        this.acForm.description = object.description
        this.object = object
        this.$refs['edit-ac'].show()
      },
      hideEditACModal() {
        this.error = ''
        this.selectedAC = []
        this.selectedP = []
        this.acForm.description = ''
        this.selectedRC = []
        this.loadContent()
        this.$refs['edit-ac'].hide()
      },
      showACConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-ac'].show()
      },
      hideACConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-ac'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      closeViewModal () {
        this.viewACModal = false;
        this.selectedAC = []
      },
      openViewModal(object) {
        this.selectedAC = object
        this.viewACModal = true
      },
      loadContent() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.system = response.data;
          self.setDisabledValidations();
        }, function() {});
      },
      loadAccessControl() {
        let self = this;
        piincHttp.get('systems/' + this.system.slug + '/access-controls', { params:
          {
            client: this.getClient.slug,
          }
        }).then(function(response) {
          self.acTableItems = response.data;
          self.acLoading = false;
        }, function() {});
      },
      confirmDeleteAC(object) {
        let self = this;
        piincHttp.delete('systems/' + this.system.slug + '/access-controls/' + object.id).then(function() {
          self.hideACConfirmDeleteModal();
          self.loadAccessControl();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('systems.access_control.delete.success'))
        }, function() {});
      },
      acFormSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedAC && this.selectedAC.id) {
          formData.append("access_control_id", this.selectedAC.id);
        }

        formData.append("system", this.system.slug);
        formData.append("description", this.acForm.description);

        if (this.selectedP) {
          formData.append("provisioning", this.selectedP.value);
        }

        if (this.selectedRC) {
          formData.append("re_certification", this.selectedRC.value);
        }

        piincHttp.post('/systems/' + this.system.slug + '/access-controls', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('systems.access_control.create.success'))
          self.hideCreateACModal();
          self.buttonDisabled = false;
          self.loadAccessControl();
          self.$emit('updated');
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.access_control_id) {
              self.error += ' ' + error.data.errors.access_control_id[0]
            }
          }
        })
      },
      formEditACSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedAC) {
          this.acForm.access_control_id = this.selectedAC.id;
        }

        this.acForm.provisioning = this.selectedP.value
        this.acForm.re_certification = this.selectedRC.value

        piincHttp.put('systems/' + this.system.slug + '/access-controls/' + this.object.id, this.acForm).then(function() {
          self.hideEditACModal();
          self.loadAccessControl();
          self.buttonDisabled = false;
          self.$toastr('success', self.$t('systems.access_control.edit.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.access_control_id) {
              self.error += ' ' + error.data.errors.access_control_id[0]
            }
          }
        })
      },
      loadAC(query) {
        let self = this;
        piincHttp.get('access-controls', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.acItems = response.data.items
          if (self.acItems && !self.acItems.length && !query) {
            self.acItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.acItems && self.acItems.length) {
            self.provisioningOptions = []
            self.reCertificationOptions = []
            _.forEach(self.acItems[0].provisioningOptions, function(item) {
              let object = {
                name: self.$t('systems.access_control.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.provisioningOptions.push(object)
            })
            _.forEach(self.acItems[0].reCertificationOptions, function(item) {
              let object = {
                name: self.$t('systems.access_control.' + self.$options.filters.slugify(item)),
                value: item
              }
              self.reCertificationOptions.push(object)
            })

          }
          self.setDisabledValidations();
        }, function() {});
      },
      setDisabledValidations() {
        this.disabledValidationOptions = []
        if (this.system.accessControlsValidation.provisioning == false) {
          this.disabledValidationOptions.push('Provisioning')
        }
        if (this.system.accessControlsValidation.re_certification == false) {
          this.disabledValidationOptions.push('Re-certification')
        }
      }
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        this.loadAC();
      }
      if (this.system && this.system.id) {
        this.loadTasks('update_access_control');
        this.loadAccessControl();
        this.validationOptions = _.cloneDeep(this.system.accessControlValidationOptions)
      }


      this.loadGuides('update_access_control')
    }
  }
</script>
